import { render, staticRenderFns } from "./AdminSider.vue?vue&type=template&id=4e2f10d4&scoped=true&"
import script from "./AdminSider.vue?vue&type=script&lang=ts&"
export * from "./AdminSider.vue?vue&type=script&lang=ts&"
import style0 from "./AdminSider.vue?vue&type=style&index=0&id=4e2f10d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2f10d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/business/yq-monitor-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e2f10d4')) {
      api.createRecord('4e2f10d4', component.options)
    } else {
      api.reload('4e2f10d4', component.options)
    }
    module.hot.accept("./AdminSider.vue?vue&type=template&id=4e2f10d4&scoped=true&", function () {
      api.rerender('4e2f10d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/admin/components/AdminSider.vue"
export default component.exports